/**
 * Pure helper functions for determining whether credit event toasts should be shown.
 * Extracted for testability — AuthContext uses these to decide toast calls.
 */

interface SyncedUserWithCreditFlags {
  welcomeCredits?: boolean;
  refillHappened?: boolean;
  [key: string]: unknown;
}

/**
 * Returns true if a welcome credits toast should be shown.
 * Only true on new user signup when the server set welcomeCredits=true.
 */
export function shouldShowWelcomeToast(syncedUser: SyncedUserWithCreditFlags): boolean {
  return syncedUser.welcomeCredits === true;
}

/**
 * Returns true if a refill toast should be shown.
 * Only true when a drip refill actually happened on this login (refillHappened=true).
 */
export function shouldShowRefillToast(syncedUser: SyncedUserWithCreditFlags): boolean {
  return syncedUser.refillHappened === true;
}
